import React, { useState } from "react";
import { FaRegStar } from "react-icons/fa";
import { FiFilter } from "react-icons/fi";
import { HiMiniPencilSquare } from "react-icons/hi2";
import user from "../../assets/img/user.png";

const messages = [
  {
    taskName: "Filter by Category",
    user: user,
    name: "John Doe",
    desc: "Working on category filtering feature.",
  },
  {
    taskName: "Update User Profile",
    user: user,
    name: "Jane Smith",
    desc: "Updating user profile details.",
  },
  {
    taskName: "Fix Bugs",
    user: user,
    name: "Michael Johnson",
    desc: "Resolving reported issues in the system.",
  },
];

function CreditAgent() {
  const [activeTab, setActiveTab] = useState(0);

  // Define your tabs with their respective titles and content
  const tabs = [
    {
      title: "Activity",
      content: (
        <>
          <div className="filter_box">
            <button className="btn btn_s">
              <HiMiniPencilSquare className="icons" /> Send message
            </button>
            <button className="btn btn_s filter_btn">
              <FiFilter className="icons" />
            </button>
          </div>
          <div className="messages_area">
            <h4 className="date_title">Today</h4>
            <div className="messages_list">
              {messages.map((message, index) => (
                <div className="message" key={index}>
                  <div className="header">
                    <FaRegStar className="icons" />
                    <p>{message.taskName}</p>
                  </div>
                  <div className="user_area">
                    <img src={message.user} alt={message.name} />
                    <div className="text_area">
                      <h4>{message.name}</h4>
                      <p>{message.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      ),
    },
    { title: "Archive", content: <div>Content for Tab 2</div> },
    { title: "Messages I've sent", content: <div>Content for Tab 3</div> },
  ];

  return (
    <div>
      <section className="credit_agent">
        <div className="tabs-container">
          <h4 className="p-4">My Account</h4>
          {/* Render tab titles */}
          <div className="agent_tabs">
            {tabs.map((tab, index) => (
              <button
                key={index}
                className={`inbox_tab ${activeTab === index ? "active" : ""}`}
                onClick={() => setActiveTab(index)}
              >
                {tab.title}
              </button>
            ))}
          </div>

          {/* Render active tab content */}
          <div className="tab-content">{tabs[activeTab].content}</div>
        </div>
      </section>
    </div>
  );
}

export default CreditAgent;
